import { SYMBOL_SOURCE_STATUS_LABELS } from '@/models';
import type { SymbolSourceStatus } from '@/models';

const STATUS_CLASSES: Record<SymbolSourceStatus, string> = {
  OK: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200',
  NOT_FOUND: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200',
  ERROR: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200',
  PENDING: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
  UNSET: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400',
};

interface Props {
  status: SymbolSourceStatus;
  title?: string;
}

/** Fetch state of one price source (Google Sheets / EODHD) of a symbol. */
export default function SymbolSourceBadge({ status, title }: Props) {
  return (
    <span
      title={title}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${STATUS_CLASSES[status]}`}
    >
      {SYMBOL_SOURCE_STATUS_LABELS[status] ?? status}
    </span>
  );
}
